import default_env from "./env.config.default.js";

const localhost = {
    ...default_env,
    APIURL: "http://localhost:8004/",
    FRONT_URL: "http://localhost:3000/",
    INSTOREVIEW: "https://operaciones.instoreview.cl:8080",
    GS1: "75d1bde986123e3269c9ae28c59bd2caab619aa2afd02e402838af2a9dd998a8",
};

export default localhost;
